<template>
<div class=""  style="padding:0 20px;">

  <el-form ref="formBasic" :model="$abstract.profile.row" @submit.native.prevent="onSubmit" :rules="rules" label-width="180px" style="margin-top:20px;" class="label-30">


   <div class="title_h1 yo-color-primary">GENERAL DATA</div>
   <div class="yo-text-s yo-color-secondary" style="margin:8px 0 24px 0;" v-if="$abstract.profile.rowIsNew">» New Abstract</div> 
   <div class="yo-text-s yo-color-secondary" style="margin:8px 0 24px 0;" v-else>» {{$abstract.profile.row.titolo}}</div> 
   

   <div class="row " style="margin-top:20px;">

      <div class="col s12">
      <el-form-item label="Title" prop="titolo">
        <el-input  v-model="$abstract.profile.row.titolo"></el-input>
      </el-form-item>
      </div> 
      <div class="col s12">
      <el-form-item label="Keywords" prop="parolechiave">
        <el-input  v-model="$abstract.profile.row.parolechiave"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12" v-if="$evento._topic.length>0">
      <el-form-item label="Topic" prop="topic">
        <el-select v-model="$abstract.profile.row.topic"  placeholder="Choose from list" style="width:100%;">
          <el-option v-for="item in $evento._topic" :key="item.id" :label="item.nome" :value="item.id" ></el-option>
        </el-select>
      </el-form-item>
      </div> 

      <div class="col s12"><div class="el-form-item__content" style="line-height:1.5em;margin-bottom:8px;">
      In each edition, the best poster is selected by the organizers. 	
      <br />
      When submitting an abstract for a poster, you are requested to confirm if you would like to participate in the selection of the award, by flagging the box.
      </div></div>


      <div class="col s12" >
      <el-form-item label="" prop="bestposterawards">
        <el-checkbox v-model="$abstract.profile.row.bestposterawards">Best Poster Awards</el-checkbox>
      </el-form-item>
      </div> 

            
      

      <div class="col s12"><div class="el-form-item__content" style="line-height:1.5em;margin-bottom:8px;">
        During ESPHM there will be the session “Flash talks” dedicated to short oral presentations (3 minutes each).
        <br />
        Please confirm by flagging the box if you agree to deliver an oral presentation during this session in case of final selection and acceptance by the International Scientific Committee.
      </div></div>

      <div class="col s12" >
      <el-form-item label="" prop="flashposterpresentation">
        <el-checkbox v-model="$abstract.profile.row.flashposterpresentation">Flash Poster Presentation</el-checkbox>
      </el-form-item>
      </div> 



      <div class="col s12"><div class="el-form-item__content" style="line-height:1.5em;margin-bottom:8px;">
        Selected abstracts will be invited to make an oral presentation during the parallel sessions of the Symposium.
        <br />
        Please confirm by flagging the box if you agree to deliver an oral presentation in case  of final selection and acceptance by the International Scientific Committee.
      </div></div>

      <div class="col s12" >
      <el-form-item label="" prop="oral">
        <el-checkbox v-model="$abstract.profile.row.oral">Oral communication</el-checkbox>
      </el-form-item>
      </div> 





      <div class="col s12"><div class="el-form-item__content" style="line-height:1.5em;margin-bottom:8px;">
        The International Scientific Committee will make a selection of posters for Chaired Poster Presentation Sessions during the lunch break on Thursday.
        <br />
        In case your work is selected, please confirm your willingness to participate by flagging the box.
      </div></div>

      <div class="col s12" >
      <el-form-item label="" prop="oral">
        <el-checkbox v-model="$abstract.profile.row.chairedposterpresentation">Chaired Poster Presentation Sessions</el-checkbox>
      </el-form-item>
      </div> 
      



   </div>  








    <div class="row pad" style="margin-top:20px;border-top:1px solid grey;padding-top:30px;padding-bottom:30px;">
      <div class="col s6 m4 offset-m2">
          <el-button style="width:100%;margin:10px 0;"  @click="onCancel">Cancel, go back</el-button>
      </div>
        
      <div class="col s6 m4 offset-m2">
          <el-button type="primary" @click="onSubmit" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;" >Save</el-button>
      </div>
    </div>


    </el-form>
<!-- 
<el-button type="primary" @click="emailFirst" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;">Email</el-button>
-->
</div>
</template>

<script>
export default {
  name: 'abstract-profile',
  components: {

  },
  data() {
    return {
      loading: {}
    }
  },
  async created () {
    console.log("Arrivo al abstract-profile.vue con id "+this.$abstract.profile.row.id)
    console.log(this.$abstract.profile.row.bestposterawards)
    if(typeof this.$abstract.profile.row.id == 'undefined')
      await this.isNew()

    console.log(this.$abstract.profile.row.oral)
    this.$abstract.profile.row.oral = (this.$abstract.profile.row.oral==1) ? true : false
    console.log(this.$abstract.profile.row.bestposterawards)
    this.$abstract.profile.row.bestposterawards = (this.$abstract.profile.row.bestposterawards==1) ? true : false
    console.log(this.$abstract.profile.row.flashposterpresentation)
    this.$abstract.profile.row.flashposterpresentation = (this.$abstract.profile.row.flashposterpresentation==1) ? true : false
    console.log(this.$abstract.profile.row.chairedposterpresentation)
    this.$abstract.profile.row.chairedposterpresentation = (this.$abstract.profile.row.chairedposterpresentation==1) ? true : false
    console.log(this.$abstract.profile.row.paperposter)
    this.$abstract.profile.row.paperposter = (this.$abstract.profile.row.paperposter==1) ? true : false
  },
  beforeDestroy () {

  },
  methods: {
    async isNew(){
      this.$abstract.profile.new().then((response) =>  {
        this.$abstract.profile.row.contatto = this.$contatto.profile.row.id
        this.$abstract.profile.row.evento = this.$evento.profile.row.id
        this.$abstract.profile.row.iniziatoil = this.$moment().format('YYYY-MM-DD HH:mm:00')
        this.$abstract.init()
      })
    },
    onCancel() {
      this.$router.push('/home/')
    },
    onSubmit() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {  
          this.loading = this.$loading({lock: true, text: 'Loading in progress, do not reload the page.....just wait!', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
          this.Save()
        } else {
          this.$alert('Not all fields have been filled in correctly!', this.$teras.alert_error)
          return false;
        }
      });
    },
    async Save(){
      this.$abstract.profile.row.oral = (this.$abstract.profile.row.oral) ? 1 : 0
      this.$abstract.profile.row.bestposterawards = (this.$abstract.profile.row.bestposterawards) ? 1 : 0
      this.$abstract.profile.row.flashposterpresentation = (this.$abstract.profile.row.flashposterpresentation) ? 1 : 0
      this.$abstract.profile.row.chairedposterpresentation = (this.$abstract.profile.row.chairedposterpresentation) ? 1 : 0
      this.$abstract.profile.row.paperposter = (this.$abstract.profile.row.paperposter) ? 1 : 0
      this.$abstract.profile.row.modificatoil = this.$moment().format('YYYY-MM-DD HH:mm:00')
      this.$abstract.profile.row.previewil = '0000-00-00 00:00:00'
      this.$abstract.profile.row.preview = ''
      await this.$abstract.profile.save() 
      await this.$contatto.getAbstract() 
      this.loading.close()
      this.$router.push('/home/')      
    }

  },
  computed: {
    rules:function() {
      var rulesNow = {
        titolo: [
          { required: true, message: 'Title is mandatory' }
        ],
        parolechiave: [
          { required: true, message: 'Keywords are mandatory'  }
        ],
        topic: [
          { required: (this.$evento._topic.length>0), message: 'Topic is mandatory'}
        ]
      }
      return rulesNow
    }
  }
}
</script>
<style scoped>
</style>